import React from 'react'
import { fmtLeadTime, reasonLabel, reasonTone } from './model'
import { LeadLink } from './SoldTable'
import BuyerResponseChips from './BuyerResponseChips'

// Accepted-not-sold and rejected leads: why, and what each buyer said.
export default function NotSoldTable({ leads, timezone, palette }) {
  return (
    <table className="sl-table">
      <thead>
        <tr>
          <th>Lead ID</th>
          <th>Origin</th>
          <th>Reason</th>
          <th>Buyer responses</th>
          <th>Time (ET)</th>
        </tr>
      </thead>
      <tbody>
        {leads.map((l) => {
          const { label, known } = reasonLabel(l.reason)
          const tone = reasonTone(l.reason)
          return (
            <tr key={l.lead_id}>
              <td><LeadLink id={l.lead_id} /></td>
              <td>{l.origin}</td>
              <td style={{ minWidth: 160 }}>
                <span style={{
                  display: 'inline-block', padding: '2px 8px', borderRadius: 6, fontSize: 11, fontWeight: 600,
                  background: tone.bg, color: known ? tone.fg : 'var(--text-muted)', whiteSpace: 'nowrap',
                }}>
                  {label}
                </span>
                {l.detail && <div style={{ marginTop: 4, fontSize: 12, color: 'var(--text-secondary)' }}>{l.detail}</div>}
              </td>
              <td><BuyerResponseChips responses={l.buyer_responses} palette={palette} /></td>
              <td style={{ whiteSpace: 'nowrap' }}>{fmtLeadTime(l.created_at, timezone)}</td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
